import React from "react";
import { FaFileInvoiceDollar, FaReceipt, FaBuilding, FaSearchDollar, FaRegClipboard, FaCalculator } from "react-icons/fa";

const services = [
  {
    title: "GST Registration & Filing",
    desc: "Fast registration, monthly/quarterly returns, notices support—avoid penalties.",
    icon: FaReceipt
  },
  {
    title: "Income Tax Return (ITR) Filing",
    desc: "Salaried, business, freelancers—maximize eligible deductions with accuracy.",
    icon: FaFileInvoiceDollar
  },
  {
    title: "Company & Startup Registration",
    desc: "Private limited / LLP / MSME—end-to-end registration with guidance.",
    icon: FaBuilding
  },
  {
    title: "Audit & Assurance",
    desc: "Statutory/Internal audits to keep your books clean and investor-ready.",
    icon: FaSearchDollar
  },
  {
    title: "ROC & Compliance",
    desc: "Annual filings, director KYC, compliances—stay protected from penalties.",
    icon: FaRegClipboard
  },
  {
    title: "Accounting & Bookkeeping",
    desc: "Monthly bookkeeping, MIS, payroll basics—clarity for better decisions.",
    icon: FaCalculator
  }
];

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="mx-auto max-w-7xl container-pad">
        <h2 className="section-title">Services</h2>
        <p className="section-subtitle">
          Practical CA services for startups, MSMEs, salaried individuals, and corporates—delivered with clear timelines and transparent pricing.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s) => (
            <div key={s.title} className="card p-6 transition hover:-translate-y-0.5 hover:shadow-soft">
              <div className="flex items-start gap-4">
                <div className="h-12 w-12 rounded-2xl bg-navy-50 flex items-center justify-center border border-navy-900/5">
                  <s.icon className="text-navy-900" size={22} />
                </div>
                <div>
                  <h3 className="font-heading text-lg text-navy-900">{s.title}</h3>
                  <p className="mt-1 text-sm text-navy-800/75">{s.desc}</p>
                </div>
              </div>

              <div className="mt-5">
                <a href="#contact" className="inline-flex items-center gap-2 text-sm font-semibold text-navy-900 hover:underline">
                  Get Expert Help <span aria-hidden>→</span>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-2xl border border-navy-900/10 bg-navy-50 p-5 sm:p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <div className="font-heading text-lg text-navy-900">Not sure what you need?</div>
              <div className="text-sm text-navy-800/75">Tell us your situation—we’ll suggest the right service and a simple document checklist.</div>
            </div>
            <a href="#contact" className="btn-primary">Get a Quick Checklist</a>
          </div>
        </div>
      </div>
    </section>
  );
}
